export const contactsData = {
    email: 'tomerpranshu11@gmail.com',
    phone: '+919026401421',
    address: 'Gujaini, Kanpur Nagar, Uttar Pradesh, India - 208022',
    sheetAPI: ''
}